import { CreateActionTypeUseCase } from '@/application/actionType/createActionTypeUseCase';
import { DeleteActionTypeUseCase } from '@/application/actionType/deleteActionTypeUseCase';
import { GetActionTypesUseCase } from '@/application/actionType/getActionTypesUseCase';
import { UpdateActionTypeUseCase } from '@/application/actionType/updateActionTypeUseCase';
import { actionTypeApiRepository } from '@/infra/repositories/actionTypeApi.repository';

let _getActionTypeManagementUseCase: GetActionTypesUseCase | null = null;
let _createActionTypeManagementUseCase: CreateActionTypeUseCase | null = null;
let _updateActionTypeManagementUseCase: UpdateActionTypeUseCase | null = null;
let _deleteActionTypeManagementUseCase: DeleteActionTypeUseCase | null = null;

export const getActionTypeManagementUseCase = (): GetActionTypesUseCase => {
  if (!_getActionTypeManagementUseCase) {
    _getActionTypeManagementUseCase = new GetActionTypesUseCase(
      actionTypeApiRepository,
    );
  }
  return _getActionTypeManagementUseCase;
};

export const createActionTypeManagementUseCase =
  (): CreateActionTypeUseCase => {
    if (!_createActionTypeManagementUseCase) {
      _createActionTypeManagementUseCase = new CreateActionTypeUseCase(
        actionTypeApiRepository,
      );
    }
    return _createActionTypeManagementUseCase;
  };

export const updateActionTypeManagementUseCase =
  (): UpdateActionTypeUseCase => {
    if (!_updateActionTypeManagementUseCase) {
      _updateActionTypeManagementUseCase = new UpdateActionTypeUseCase(
        actionTypeApiRepository,
      );
    }
    return _updateActionTypeManagementUseCase;
  };

export const deleteActionTypeManagementUseCase =
  (): DeleteActionTypeUseCase => {
    if (!_deleteActionTypeManagementUseCase) {
      _deleteActionTypeManagementUseCase = new DeleteActionTypeUseCase(
        actionTypeApiRepository,
      );
    }
    return _deleteActionTypeManagementUseCase;
  };

export const resetActionTypeContainer = (): void => {
  _getActionTypeManagementUseCase = null;
  _createActionTypeManagementUseCase = null;
  _updateActionTypeManagementUseCase = null;
  _deleteActionTypeManagementUseCase = null;
};
